export enum TrackEventNames {
	Download = "download",
	ToStaff = "to_staff",
	ToBooking = "to_booking",
	ToAnalytics = "to_analytics",
	ToSupport = "to_support",
	ToColleaguesShifts = "to_colleagues_shifts",
	PunchIn = "punch_in",
	PunchOut = "punch_out",
	Filter = "filter",
	ToggleRead = "toggle_read",
	AvailabilitySettings = "availability_settings",
	AddAbsence = "add_absence",
	TradeShift = "trade_shift",
	SellShift = "sell_shift",
	ExportSchedule = "export_schedule",
	RequestAbsence = "request_absence",
	ToggleOpenCalendar = "toggle_open_calendar",
	EmptyDayClick = "empty_day_click",
	ShiftClick = "shift_click",
	BankAccountValidationError = "bank_account_validation_error",
}
